export default "__VITE_ASSET__CM6d5_Mt__"